import { useOnlineStatus } from '../hooks/useOnlineStatus';

/**
 * Slim, persistent banner shown at the top of the app shell whenever the
 * renderer detects it has lost connectivity. It does NOT block the UI - the
 * user can still navigate and read cached data - but it sets expectations
 * that any "Save"/"Create"/"Delete" action will be rejected by the API client
 * with an offline error.
 *
 * Mount once near the root layout (e.g. inside `App.tsx`). Internally it
 * subscribes to the online-status store so it appears and disappears as the
 * health probe flips state.
 */
export function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 top-0 z-50 bg-amber-100 text-amber-900 text-sm border-b border-amber-300 px-4 py-2 flex items-center justify-center gap-2"
    >
      <span className="inline-block w-2 h-2 rounded-full bg-amber-600" aria-hidden />
      <span>
        You are offline - viewing cached data. Changes are disabled until your
        connection returns.
      </span>
    </div>
  );
}
